/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Choose_MonthlyInputs */

const en_pricing_choose_monthly = /** @type {(inputs: Pricing_Choose_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose monthly`)
};

const es_pricing_choose_monthly = /** @type {(inputs: Pricing_Choose_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir mensual`)
};

/**
* | output |
* | --- |
* | "Choose monthly" |
*
* @param {Pricing_Choose_MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_choose_monthly = /** @type {((inputs?: Pricing_Choose_MonthlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Choose_MonthlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_choose_monthly(inputs)
	return en_pricing_choose_monthly(inputs)
});